import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // Added Router import
import { DavinciLoadWidgetService, DaVinciSuccessResponse } from '../davinci-services/davinci-load-widget.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-davinci-challenge',
  templateUrl: './davinci-challenge.component.html',
  styleUrls: ['./davinci-challenge.component.scss']
})
export class DavinciChallengeComponent implements OnInit, OnDestroy {
  @ViewChild('davinciContainer', { static: true })
  davinciContainer!: ElementRef<HTMLElement>;
  private queryParamsSub: Subscription | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router, // Injected Router here
    private davinciService: DavinciLoadWidgetService
  ) { }

  ngOnInit() {
    this.queryParamsSub = this.activatedRoute.queryParams.subscribe(params => {
      const { username, code } = params;

      if (!username || !code) {
        this.davinciContainer.nativeElement.innerText = 'Error: Required information (username or code) is missing from the link.';
        return;
      }

      const flowInputData = {
        username,
        code
      };

      this.davinciService.renderFlow({
        policyId: environment.ping_challenge_flow_policyId,
        targetElement: this.davinciContainer.nativeElement,
        flowInputData,
        onReady: () => {
          console.log('DaVinci widget is ready to render.');
        }
      }).subscribe({
        next: (response: DaVinciSuccessResponse) => {
          console.log('Challenge flow completed successfully!', response);
          // Handle successful authentication here
        },
        error: (err) => {
          console.error('An error occurred during the DaVinci challenge flow:', err);
          this.router.navigate(['/error']); // Now works because this.router is defined
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.queryParamsSub) {
      this.queryParamsSub.unsubscribe();
    }
  }
}
